<template>
    <div class="calendar-wrapper">
        <div class="grid calendar-month-wrapper">
            <div>
                <button @click.prevent="previousMonth">
                    <svg class="h-6 w-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
                    </svg>
                </button>
            </div>
            <div class="text-center">
                <span class="text-lg font-bold text-gray-800">{{ currentMonth }} {{ currentYear }}</span>
            </div>
            <div>
                <button @click.prevent="nextMonth">
                    <svg class="h-6 w-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                    </svg>
                </button>
            </div>
        </div>
        <div class="grid grid-cols-7">
            <div
                v-for="day in daysOfWeek"
                :key="day"
                class="w-1/7 p-4 text-center calendar-day-title-wrapper"
            >
                <span class="calendar-day-title-text">{{ day }}</span>
            </div>
        </div>
        <div class="grid grid-cols-7">
            <div
                v-for="n in blankDaysBeforeFirstDay"
                :key="'blank-' + n"
                 class="calendar-item text-center relative rounded-sm text-lg font-bold"
            />
            <div
                v-for="(percentage, date) in calendarData"
                :key="date"
                role="button"
                class="calendar-item text-center relative rounded-sm text-lg font-bold"
                :class="[getMarkerClass(percentage), {'active': currentDay === date}]"
                @click.prevent="selectDate(date, percentage)"
            >
                {{ formatDate(date) }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        calendarData: {
            type: Object,
            default: () => ({}),
        },
        currentDateData: {
            type: Object,
            default: () => ({}),
        },
        disabledDays: {
            type: Object,
            default: () => ({}),
        },
        defaultDay: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            currentMonthNumber: this.currentDateData.currentMonthNumber,
            currentYear: this.currentDateData.currentYear,
            daysOfWeek: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'],
            currentDay: this.defaultDay
        };
    },
    watch: {
        defaultDay() {
            this.currentDay = this.defaultDay
        }
    },
    computed: {
        currentMonth() {
            return (this.currentDateData.currentMonthName[0].toUpperCase() + this.currentDateData.currentMonthName.substring(1))
        },
        blankDaysBeforeFirstDay() {
            const firstDayOfMonth = new Date(this.currentYear, this.currentMonthNumber - 1, 1).getDay()
            const blankDays = (firstDayOfMonth + 6) % 7
            return Array.from({ length: blankDays }, (_, i) => i)
        },
    },
    methods: {
        previousMonth() {
            if (this.currentMonthNumber > 1) {
                this.currentMonthNumber -= 1;
            } else {
                this.currentMonthNumber = 12;
                this.currentYear -= 1;
            }
            this.$emit('setDate', {
                month: this.currentMonthNumber,
                year: this.currentYear
            });
        },
        nextMonth() {
            if (this.currentMonthNumber < 12) {
                this.currentMonthNumber += 1;
            } else {
                this.currentMonthNumber = 1;
                this.currentYear += 1;
            }
            this.$emit('setDate', {
                month: this.currentMonthNumber,
                year: this.currentYear
            });
        },
        getMarkerClass(percentage) {
            if (percentage > 100) {
                return 'disabled-calendar-item';
            } else if (percentage >= 75) {
                return 'green-calendar-item';
            } else if (percentage >= 25) {
                return 'yellow-calendar-item';
            } else {
                return 'red-calendar-item';
            }
        },
        formatDate(date) {
            return date.split('-').pop();
        },
        selectDate(date, percentage) {
            if (percentage <= 100 && percentage > 0) {
                this.currentDay = date
                this.$emit('selectDate', date)
            }
        }
    },
};
</script>

<style scoped>
.calendar-item.active {
    box-shadow: 0 0 5px 2px #27a38894;
}
</style>
